<template>
  <Component
    :is="scrollable ? IAIScrollableContainer : 'div'"
    variant="secondary"
    button-transform-x="25"
    button-transform-y="-22"
    scroll-distance="400"
  >
    <div
      :class="[
        scrollable ? 'flex w-full gap-6' : 'grid w-full grid-cols-1 gap-x-6 gap-y-8 md:grid-cols-2 xl:grid-cols-3',
      ]"
    >
      <template v-if="isLoading">
        <div v-for="index in skeletonCount" :key="index" :class="scrollable ? 'w-[360px] flex-shrink-0' : ''">
          <ProfileShopSkeleton :last-profiles-amount="1" />
        </div>
      </template>

      <template v-else-if="profiles?.length">
        <ProfileCard
          v-for="profile in profiles"
          :key="profile.bundle_id"
          :profile="profile"
          :source="source"
          :selected-compare-style-image="selectedCompareStyleImage"
          :class="scrollable ? 'w-[360px] flex-shrink-0' : ''"
        />
      </template>
    </div>
  </Component>
</template>

<script lang="ts" setup>
import type { ProfileGridObject } from "@/features/profile-shop/services/api";
import ProfileCard from "@/features/profile-shop/components/profileCard/ProfileCard.vue";
import ProfileShopSkeleton from "@/features/profile-shop/components/profileGrid/ProfileShopSkeleton.vue";
import { ProfileLinkSource } from "@/features/profile-shop/utils";
import { IAIScrollableContainer } from "@/core-ui-vue";

withDefaults(
  defineProps<{
    profiles?: ProfileGridObject[];
    isLoading: boolean;
    skeletonCount?: number;
    selectedCompareStyleImage: string;
    source: ProfileLinkSource;
    scrollable?: boolean;
  }>(),
  {
    skeletonCount: 6,
    source: "main_page",
    scrollable: false,
  }
);
</script>
